import React from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import TeamInsightsContainer from './TeamPlayersDataContainer'

const TeamPlayersData = ({
  changeTab,
}) => (
    <TeamInsightsContainer changeTab={changeTab} />
)

TeamPlayersData.propTypes = {
  changeTab: PropTypes.func.isRequired,
}

export default withRouter(TeamPlayersData)
